module.exports = __webpack_public_path__ + "static/media/transgender-alt.6d91dd91.svg";